import { render, staticRenderFns } from "./BlockEditAdmin.vue?vue&type=template&id=1e543b56&scoped=true&"
import script from "./BlockEditAdmin.vue?vue&type=script&lang=js&"
export * from "./BlockEditAdmin.vue?vue&type=script&lang=js&"
import style0 from "./BlockEditAdmin.vue?vue&type=style&index=0&id=1e543b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e543b56",
  null
  
)

export default component.exports